import { render, staticRenderFns } from "./Crucigrama.vue?vue&type=template&id=e792521a&scoped=true&"
import script from "./Crucigrama.vue?vue&type=script&lang=js&"
export * from "./Crucigrama.vue?vue&type=script&lang=js&"
import style0 from "./Crucigrama.vue?vue&type=style&index=0&id=e792521a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e792521a",
  null
  
)

export default component.exports